// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PrescriberListRequestModel {
    static getAttributeTypeMap() {
        return PrescriberListRequestModel.attributeTypeMap;
    }
}
PrescriberListRequestModel.discriminator = undefined;
PrescriberListRequestModel.additionalProperties = false;
PrescriberListRequestModel.attributeTypeMap = [
    {
        "name": "prescriberIds",
        "baseName": "prescriberIds",
        "type": ""
    },
];
//# sourceMappingURL=prescriberListRequestModel.js.map